module.exports = __webpack_public_path__ + "static/itismyquote.com-81766031fdf997c5a1002bf5d2f6dd0a.png";